import { render, staticRenderFns } from "./UserCalendar.vue?vue&type=template&id=416f7142&scoped=true"
import script from "./UserCalendar.vue?vue&type=script&lang=js"
export * from "./UserCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f7142",
  null
  
)

export default component.exports